import { useMemo } from 'react';
import useFlags from 'components/modules/implementation/Fsp/Detail/common/hooks/useFeatureFlags';

export default function usePalIfpEnrolledUsersEnabled() {
  const { data, loading: flagLoading } = useFlags(
    'ontrac-pal-ifp-enrolled-users'
  );

  return useMemo(
    () =>
      !flagLoading &&
      data !== null &&
      data.FlagValue !== null &&
      data.FlagValue,
    [flagLoading, data]
  );
}
